import { render, staticRenderFns } from "./SocialHandles.vue?vue&type=template&id=f5918dc2&"
import script from "./SocialHandles.vue?vue&type=script&lang=js&"
export * from "./SocialHandles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports